var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSammelnHeaderMenuMain({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 27,
    viewBox: "0 0 29 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.2938 3.19258V7.98146H3.51545V3.19258H8.2938ZM0.329881 0V11.174H11.4794V0H0.329881ZM16.2577 0H29V3.19258H16.2577V0ZM16.2577 11.174H29V14.3666H16.2577V11.174ZM16.2577 22.3481H29V25.5407H16.2577V22.3481ZM12.6056 19.4861L10.3531 17.2286L5.10823 22.485L2.25253 19.6231L0 21.8805L5.10823 27L12.6056 19.4861Z",
    fill: "#EEA111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSammelnHeaderMenuMain);
export default __webpack_public_path__ + "static/media/sammeln_header_menu_main.2a80b5dcaa72c47effb9f90983aab6bf.svg";
export { ForwardRef as ReactComponent };